import { atom, useAtomValue } from "jotai";

interface UploadStatus {
  [releaseTrackId: number]: number;
}

export const supplyChainMultiUploadProgressAtom = atom<UploadStatus>({});

export const updateUploadProgressAtom = atom(
  (get) => get(supplyChainMultiUploadProgressAtom),
  (
    get,
    set,
    { releaseTrackId, percent }: { releaseTrackId: number; percent: number },
  ) => {
    set(supplyChainMultiUploadProgressAtom, {
      ...get(supplyChainMultiUploadProgressAtom),
      [releaseTrackId]: percent,
    });
  },
);

export const useGetTrackUploadPercentage = (releaseTrackId: number) => {
  const uploadPercentages = useAtomValue(supplyChainMultiUploadProgressAtom);
  return uploadPercentages[releaseTrackId];
};
